import { useCallback, useState } from 'react';

function deepFreeze(obj) {
  if (Object.isFrozen(obj)) return obj;

  Object.getOwnPropertyNames(obj).forEach(name => {
    if (typeof obj[name] !== 'object' || obj[name] === null) return;
    deepFreeze(obj[name]);
  });

  return Object.freeze(obj);
}

const useFrozenState = (initialValues = {}) => {
  const [rawState, setRawState] = useState(initialValues);
  const setState = useCallback(
    next => setRawState((prevState, ...args) => (typeof next === 'function' ? next(deepFreeze(prevState), ...args) : next)),
    [],
  );

  return [deepFreeze(rawState), setState];
};

export default useFrozenState;
